import { CSSProperties } from 'react';

export const container: CSSProperties = {
  width: '100%',
};

export const body1: CSSProperties = {
  backgroundColor: '#56C0FF',
  margin: 'auto',
  width: '100%',
};
export const body2: CSSProperties = {
  backgroundColor: '#FFFF3B',
  margin: 'auto',
  width: '100%',
};

